import React, { FC, useEffect, useState } from "react";
import { useWindowDimensions } from "../../../hooks";
import { IPlayer } from "../../../interfaces";

import TablePlayerMiniProfile from "../Player/TablePlayerMiniProfile";
import AvatarPosition from "./AvatarPosition";

interface IAvatarBoxHolderMemo {
    player: IPlayer;
    index: number;
    oldAngleInDegrees: number | undefined;
    angleInDegrees: number;
    ellipseWidth: number;
    ellipseHeight: number;
    avatarColor: string;
}

const AvatarBoxHolderMemo: FC<IAvatarBoxHolderMemo> = (props) => {
    const { player, index, oldAngleInDegrees, angleInDegrees, ellipseWidth, ellipseHeight, avatarColor } = props;
    const { width } = useWindowDimensions();
    const initialScreenWidthInPixels = 1500;
    const onePercentageOfBrowserWidth = width / initialScreenWidthInPixels;
    const [currentAngleInDegrees, setCurrentAngleInDegrees] = useState<number>(angleInDegrees);

    useEffect(() => {
        if (oldAngleInDegrees !== undefined)
            setCurrentAngleInDegrees(oldAngleInDegrees);

        if (oldAngleInDegrees === undefined) {
            if (angleInDegrees === 0) 
                setCurrentAngleInDegrees(360);
                
            setCurrentAngleInDegrees(angleInDegrees);
        }
        
    }, [angleInDegrees, oldAngleInDegrees]);

    const shiftTheAngle = (increment: number) => {
        setTimeout(() => {
            setCurrentAngleInDegrees(currentAngleInDegrees + increment);
        }, 50);
    }

    const angleInRadians = currentAngleInDegrees * Math.PI / 180;
    let radius = 600;

    const sineSquare = Math.sin(angleInRadians) * Math.sin(angleInRadians);
    const cosineSquare = Math.cos(angleInRadians) * Math.cos(angleInRadians);
    const equation_denominator = Math.sqrt(ellipseWidth * ellipseWidth * sineSquare + ellipseHeight * ellipseHeight * cosineSquare);
    const equation_numerator = ellipseWidth * ellipseHeight;
    radius = Math.round(equation_numerator / equation_denominator);

    const avatarProps = { index, player, ellipseWidth, radius, currentAngleInDegrees, onePercentageOfBrowserWidth, avatarColor };
    let endValue = angleInDegrees;
    
    if(oldAngleInDegrees !== undefined && angleInDegrees === 0){
        if(endValue !== oldAngleInDegrees)
        endValue = 360;
    }

    if(oldAngleInDegrees !== undefined && endValue - oldAngleInDegrees < 0){
        let saver = 0;
        saver = 360 - oldAngleInDegrees + endValue;
        endValue = oldAngleInDegrees + saver;
    }
    return (
        <div className="edge_circle" style={{ transform: `rotate(${currentAngleInDegrees}deg)`, width: `${radius}px` }} >
            {currentAngleInDegrees < endValue && shiftTheAngle(10)}
            <TablePlayerMiniProfile index={index} angleInDegrees={currentAngleInDegrees} onePercentageOfBrowserWidth={onePercentageOfBrowserWidth} player={player} />

            <AvatarPosition avatarProps={avatarProps} />
        </div>
    )
}
const AvatarBoxHolder = React.memo( AvatarBoxHolderMemo );

export default AvatarBoxHolder;